/**
 * GALERIA DE FOTOS POR SERVIÇO
 * ============================
 *
 * Este é o ÚNICO ficheiro que precisa de ser editado para mudar as fotos
 * que aparecem no site. Cada serviço pode ter entre 1 e 10 fotos.
 *
 * COMO ADICIONAR UMA FOTO
 * -----------------------
 *  1. Copiar a foto para `public/images/galeria/<pasta-do-servico>/`
 *     (por exemplo `public/images/galeria/verniz-gel/5.jpeg`)
 *  2. Acrescentar aqui em baixo, na lista desse serviço, uma linha nova:
 *        'images/galeria/verniz-gel/5.jpeg',
 *  3. Guardar. Pronto — o carrossel passa a mostrar mais uma foto.
 *
 * COMO REMOVER UMA FOTO
 * ---------------------
 *  Basta apagar (ou comentar com `//`) a linha correspondente.
 *
 * FOTOS DE ANTES / DEPOIS
 * -----------------------
 *  Em vez de um texto simples, pode-se pôr um par:
 *        { antes: 'images/galeria/microblading/antes.jpeg',
 *          depois: 'images/galeria/microblading/depois.jpeg' },
 *  O site mostra os dois lado a lado, identificados com "Antes" e "Depois".
 *  Um serviço pode ter vários pares e fotos normais misturados na mesma lista.
 *
 * NOTAS
 * -----
 *  - A chave de cada lista é o `service_id` do serviço (ver `src/data/services.js`).
 *  - A PRIMEIRA foto da lista é a que aparece como capa (nos Destaques da página
 *    inicial e como miniatura). Num par antes/depois, a capa é o "depois".
 *  - Serviços que não estejam nesta lista continuam a usar o `service_image`
 *    definido em `src/data/services.js`, exatamente como antes.
 *  - O máximo é de 10 fotos por serviço; as restantes são ignoradas.
 */

export const MAX_IMAGES_PER_SERVICE = 10;

export const serviceGallery = {
  // ---------------------------------------------------------------- Manicure
  // 2 — Manicure simples com pintura (verniz normal)
  2: [
    'images/galeria/manicure-pintura/1.jpeg',
  ],

  // 3 — Verniz Gel
  3: [
    'images/galeria/verniz-gel/1.jpeg',
    'images/galeria/verniz-gel/2.jpeg',
    'images/galeria/verniz-gel/3.jpeg',
    'images/galeria/verniz-gel/4.jpeg',
  ],

  // 4 — 1ª Aplicação de Gel/Acrygel sobre a unha
  4: [
    'images/galeria/gel-sobre-unha/1.jpeg',
    'images/galeria/gel-sobre-unha/2.jpeg',
    'images/galeria/gel-sobre-unha/3.jpeg',
  ],

  // 6 — Manutenção de Gel
  6: [
    'images/galeria/manutencao-gel/1.jpeg',
    'images/galeria/manutencao-gel/2.jpeg',
  ],

  // 9 — 1ª Aplicação de Acrygel com extensão
  9: [
    'images/galeria/acrygel-extensao/1.jpeg',
    'images/galeria/acrygel-extensao/2.jpeg',
  ],

  // ---------------------------------------------------------------- Pedicure
  // 38 — Pintura com verniz gel nos pés
  38: [
    'images/galeria/verniz-gel-pes/1.jpeg',
  ],

  // ----------------------------------------------------------- Sobrancelhas
  // 46 — Brow Lamination
  46: [
    'images/galeria/brow-lamination/1.jpeg',
  ],

  // 48 — Coloração de Sobrancelhas
  48: [
    'images/galeria/coloracao-sobrancelhas/1.jpeg',
    'images/galeria/coloracao-sobrancelhas/2.jpeg',
    'images/galeria/coloracao-sobrancelhas/3.jpeg',
    'images/galeria/coloracao-sobrancelhas/4.jpeg',
  ],

  // 49 — Microblading (par antes/depois da mesma cliente)
  49: [
    {
      antes: 'images/galeria/microblading/antes.jpeg',
      depois: 'images/galeria/microblading/depois.jpeg',
    },
  ],

  // -------------------------------------------------------------- Pestanas
  // 51 — 1ª Aplicação de pestanas Egípcia
  51: [
    'images/galeria/pestanas-egipcias/1.jpeg',
    'images/galeria/pestanas-egipcias/2.jpeg',
    'images/galeria/pestanas-egipcias/3.jpeg',
  ],

  // 53 — 1ª Aplicação de pestanas de Volume Russo
  53: [
    'images/galeria/pestanas-volume-russo/1.jpeg',
    'images/galeria/pestanas-volume-russo/2.jpeg',
    'images/galeria/pestanas-volume-russo/3.jpeg',
  ],

  // 54 — Manutenção de Aplicação de Pestanas (3 em 3 semanas)
  54: [
    'images/galeria/manutencao-pestanas/1.jpeg',
  ],

  // 55 — Lifting de Pestanas
  55: [
    'images/galeria/lifting-pestanas/1.jpeg',
    'images/galeria/lifting-pestanas/2.jpeg',
    'images/galeria/lifting-pestanas/3.jpeg',
    'images/galeria/lifting-pestanas/4.jpeg',
  ],

  // ------------------------------------------------------------ Cabeleireiro
  // 61 — Brushing
  61: [
    'images/galeria/brushing/1.jpeg',
  ],

  // 62 — Coloração
  62: [
    'images/galeria/coloracao/1.jpeg',
  ],

  // 63 — Madeixas
  63: [
    'images/galeria/madeixas/1.jpeg',
  ],

  // 64 — Balayage
  64: [
    'images/galeria/balayage/1.jpeg',
  ],

  // 65 — Alisamento
  65: [
    'images/galeria/alisamento/1.jpeg',
  ],
};

export default serviceGallery;
